/******/ (() => {
  // webpackBootstrap
  var __webpack_exports__ = {};
  Shopify.theme.jsAccounts = {
    init: function ($section) {
      this.$section = $section;
      var title = $(".account__title.title").html();
      $(".js-recover-password").on("click", function () {
        $("#login").hide();
        $("#recover").show();
        $(".account__title.title").text("RECOVER PASSWORD");
      });

      $(".cancel-recover-password").on("click", function () {
        $("#recover").hide();
        $("#login").show();
        $(".account__title.title").html(title);
      });

      this.initCompanyData();
      this.initListeners();


      $("#create_customer").on("submit", handleSumission);

      function handleSumission(event) {
        event.preventDefault();

        var data = $(this).serialize();
        var marketPlace = $("#customer_tags", this).val();
        var errorDialogue = $(".register__errors");
        var successDialogue = $(".register__success");
        

        $("#customer.register_form").addClass("form-out");
        $(".gif__loading").addClass("loader-in");

        $.post("/account", data)
          .done(function (data) {
            var errorsLog = $(data).find(".errors").text();

            // Show any errors that there may be
            if (errorsLog != "" && errorsLog != "undefined") {
              $(errorDialogue).text(errorsLog);
              $(errorDialogue).show();
              $("#customer.register_form").removeClass("form-out");
              $(".gif__loading").removeClass("loader-in");
            } else {
              if (marketPlace != "no-market") {
                $(successDialogue).text(
                  "Thank you for registering your account, we will approve your account with-in 24 business hours"
                );
                // $('#customer.register_form').removeClass('form-out');
                $(".gif__loading").removeClass("loader-in");
                $(successDialogue).addClass("success-in");
              } else {
                window.location.href = "/account";
              }
            }
          })
 
      }
    },
    initListeners: function () {
      this.$section
        .find("[data-market-selector]")
        .on("change", this.handleMarketChange.bind(this));
      this.$section
        .find("[data-location-selector]")
        .on("change", this.handleLocationChange.bind(this));
    },
    reset: function (loc, dep) {
      if (loc) {
        this.selectors.location.wrapper
          .addClass("is-hidden")
        this.selectors.location.selector.html("").removeAttr("required");;
      }
      if (dep) {
        this.selectors.department.wrapper
          .addClass("is-hidden")
        this.selectors.department.selector.html("").removeAttr("required");;
      }
    },
    handleMarketChange: function (e) {
      this.reset(true, true);
      let $target = $(e.target).find(`option[value="${e.target.value}"]`);
      let value = $target.text();
      this.selectedMarket = value;
      let locations = this.companies[value];
      let keys = Object.keys(locations);
      if (keys[0] == "None") {
        //No locations
        this.selectedLocation = "None";
        let departments = locations[keys[0]];
        if (departments[0] == "None") {
          this.selectedDepartment = "None";
        } else {
          this.initDepartmentDropdown(departments);
        }
      } else {
        //Has Locations
        this.initLocationDropdown(keys);
      }
    },
    handleLocationChange: function (e) {
      this.reset(false, true);
      let $target = $(e.target).find(`option[value="${e.target.value}"]`);
      let value = $target.text();
      this.selectedLocation = value;
      let departments = this.companies[this.selectedMarket][value];
      if (departments[0] == "None") {
        //No Departments
      } else {
        //Has Departments
        this.initDepartmentDropdown(departments);
      }
    },
    initCompanyData: async function () {
      this.selectors = {
        market: {
          wrapper: this.$section.find("[data-market-wrapper]"),
          selector: this.$section.find("[data-market-selector]"),
        },
        location: {
          wrapper: this.$section.find("[data-location-wrapper]"),
          selector: this.$section.find("[data-location-selector]"),
        },
        department: {
          wrapper: this.$section.find("[data-department-wrapper]"),
          selector: this.$section.find("[data-department-selector]"),
        },
      };

      const sheetResponse = await fetch(
        Shopify.theme_settings.companiesCSVLink
      );
      let sheetData = await sheetResponse.text();
      let finalData = $.csv.toObjects(sheetData);

      this.companies = this.mergeArray(finalData, 0);
      this.initMarketDropdown();
    },
    initMarketDropdown: function () {
      let $wrapper = this.selectors.market.wrapper.removeClass("is-hidden");
      if (!$wrapper.length) return;
      let $selector = this.selectors.market.selector
      let keys = Object.keys(this.companies);
      //Add Default
      let option = document.createElement("option");
      option.value = "None";
      option.textContent = "Select Market";
      option.disabled = true;
      option.selected = true;
      $selector[0].appendChild(option);
      keys.map((market) => {
        let option = document.createElement("option");
        option.value = "market_" + this.handleize(market);
        option.textContent = market;
        $selector[0].appendChild(option);
      });
    },
    initLocationDropdown: function (locations) {
      let $wrapper = this.selectors.location.wrapper.removeClass("is-hidden");
      if (!$wrapper.length) return;
      let $selector = this.selectors.location.selector.attr('required',true);;
      //Add Default
      let option = document.createElement("option");
      option.value = "";
      option.textContent = "Select Location";
      option.disabled = true;
      option.selected = true;
      $selector[0].appendChild(option);
      locations.map((market) => {
        let option = document.createElement("option");
        option.value = "sub_" + this.handleize(market);
        option.textContent = market;
        $selector[0].appendChild(option);
      });
    },
    initDepartmentDropdown: function (deps) {
      let $wrapper = this.selectors.department.wrapper.removeClass("is-hidden");
      if (!$wrapper.length) return;
      let $selector = this.selectors.department.selector.attr('required',true);;
      //Add Default
      let option = document.createElement("option");
      option.value = "";
      option.textContent = "Select Department";
      option.disabled = true;
      option.selected = true;
      $selector[0].appendChild(option);
      deps.map((market) => {
        let option = document.createElement("option");
        option.value = "dep_" + this.handleize(market);
        option.textContent = market;
        $selector[0].appendChild(option);
      });
    },
    handleize: function (text) {
      return text
        .toString()
        .toLowerCase()
        .replace(/\s+/g, "-") // Replace spaces with -
        .replace(/[^\w\-]+/g, "") // Remove all non-word chars
        .replace(/\-\-+/g, "-") // Replace multiple - with single -
        .replace(/^-+/, "") // Trim - from start of text
        .replace(/-+$/, ""); // Trim - from end of text
    },
    mergeArray: function (arr, currentIndex) {
      let result = {};
      let prev = false;
      let innerPrev = false;
      arr.map((single, index) => {
        let values = Object.values(single);
        let keys = Object.keys(single);
        if (values[0] && prev != values[0]) {
          prev = values[0];
          innerPrev = false;
          result[prev] = {};
        }
        if (values[1] && innerPrev != values[1]) {
          innerPrev = values[1];
          result[prev][innerPrev] = [];
        }
        if (values[2]) result[prev][innerPrev].push(values[2]);
      });
      return result;
    },
    unload: function ($section) {
      $(".js-recover-password").off();
      $(".cancel-recover-password").off();
    },
  };

  /******/
})();
